
import ReportTemplate from './ReportTemplate';
import JSZip from 'jszip';

import { pdf } from '@react-pdf/renderer';
import moment from 'moment';
import { getReportFilename } from './reportFilename';
class TaskReportService {

    /**
     * @param {string} [filenamePattern] - padrão de nomeação vindo de
     * `companyInfo.reportFilenamePattern`. Ver services/reportFilename.js.
     */
    static async build(reports, logoUrl, exportZip = false, filenamePattern) {
        try {
            if (exportZip) {
                if (!reports?.length) return;

                const MAX_CONCURRENT_PDFS = 5;
                const totalReports = reports.length;
                const concurrency = Math.min(MAX_CONCURRENT_PDFS, totalReports);

                const zip = new JSZip();
                let processedCount = 0;
                let nextIndex = 0;

                const worker = async () => {
                    while (true) {
                        const currentIndex = nextIndex++;
                        if (currentIndex >= totalReports) break;

                        const report = reports[currentIndex];
                        const { fileName, pdf } = await this.generatePDF(report, logoUrl, filenamePattern);
                        const arrayBuffer = await pdf.arrayBuffer();

                        const normalizedFileName = fileName.endsWith('.pdf') ? fileName : `${fileName}.pdf`;
                        zip.file(normalizedFileName, arrayBuffer, {
                            binary: true,
                            createFolders: false,
                        });

                        processedCount += 1;

                        if (processedCount % 10 === 0) {
                            await this.yieldToBrowser();
                        }
                    }
                };

                const workers = Array.from({ length: concurrency }, () => worker());
                await Promise.all(workers);

                await this.downloadZipContent(zip);
            } else {
                const { pdf, fileName } = await this.generatePDF(reports[0], logoUrl, filenamePattern);
                await this.downloadPDF(pdf, fileName);
            }
        } catch (error) {
            console.error('Error generating PDFs:', error);
            throw error;
        }
    }
    static async generatePDF(report, logoUrl, filenamePattern) {
        try {
            const fileName = getReportFilename(report, filenamePattern);
            // Criar elemento React com o novo componente
            const document = <ReportTemplate report={report} logoUrl={logoUrl} />;

            const pdfFile = await pdf(document).toBlob();
            return { fileName, pdf: pdfFile };
        } catch (error) {
            console.error('Error generating PDF:', error);
            throw error;
        }
    }

    static downloadPDF(pdfBlob, filename) {
        const url = URL.createObjectURL(pdfBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();
        URL.revokeObjectURL(url);
    }

    static async downloadZipContent(zip) {
        try {
            const content = await zip.generateAsync({
                type: 'blob',
                compression: 'DEFLATE',
                compressionOptions: { level: 9 }
            });

            const timestamp = moment().format('YYYY-MM-DD_HH-mm-ss');
            const zipName = `reports_${timestamp}.zip`;

            const url = URL.createObjectURL(content);
            const link = document.createElement('a');
            link.href = url;
            link.download = zipName;
            link.click();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error creating ZIP:', error);
            throw error;
        }
    }

    static yieldToBrowser() {
        return new Promise((resolve) => {
            if (typeof window !== 'undefined' && window.requestIdleCallback) {
                window.requestIdleCallback(() => resolve());
            } else {
                setTimeout(resolve, 0);
            }
        });
    }

}

export default TaskReportService;
